define(function() {
	var Backbone = require('backbone');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const theModel = require('civicsModels/fee_model');
	const urlBuilder = require('civicsUtils/buildUrlParameters');

	return IpsModelCollection.extend({
		model: theModel,
		unpaidOnly:false,
		urlRoot: 'delegate/civics-api/api/cdr/common/fees/',
		url:function(){
			var ret = this.urlRoot;
			if(this.unpaidOnly){
				var parms = urlBuilder.buildUrlParameters({
					filter:{
						property:'status',
						value:'U,I',
						operator:'In'
					}
				});
				ret+=parms;
			}
			else if( this.urlParameters){
				ret += urlBuilder.buildUrlParameters(this.urlParameters)
			}
			return ret;
		},
		parse: function(response) {
			this.responseStatus = response.responseStatus;
			return response.data;
		},
	});
});
